import type { GetUserProfileResponseType } from './get-user-profile.schema';

import { type EnvironmentalConfig } from '@/utils/environmental-config';
import { createTimeoutPromise } from '@/utils/timeout-promise';

const fetchAuthUserProfile = async (environmentalConfig: EnvironmentalConfig, getAccessTokenSilently: Function): Promise<GetUserProfileResponseType> => {
  // We don't want to wait more than 5 seconds for this request
  const timeoutPromise = createTimeoutPromise();
  const userProfileUrl = environmentalConfig.getUserProfileUrl();

  if (! userProfileUrl) {
    return Promise.reject(new Error('User profile URL is missing'));
  }

  const accessToken = await getAccessTokenSilently();

  if (! accessToken) {
    return Promise.reject(new Error('Access token is missing'));
  }

  const response = await Promise.race([
    fetch(userProfileUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    }),
    timeoutPromise
  ]);

  if (!response.ok) {
    return Promise.reject(new Error('Attempt to fetch user profile timed out'));
  }

  return response.json() as Promise<GetUserProfileResponseType>;
};

export { fetchAuthUserProfile };
